import _ from "lodash";
import React from "react";

// Design System
import { Checkbox, Tooltip } from "@toddle-edu/ds-web";

// Utils
import ConditionalWrapper from "Utils/ConditionalWrapper";

// third party libs
import classNames from "classnames";

// Scss
import classes from "./GroupedListItem.scss";

export const FILTER_ITEMS = ["icon", "titleRightComponent"];

const styles = {
  tooltipOverlayInnerStyle: {
    width: "176px",
    textAlign: "center",
  },
};

const GroupedListItem = React.memo(props => {
  const {
    t,
    option,
    isChecked,
    selectedItems,
    setSelectedItems,
    leftContainerStyle,
    optionContainerStyle,
    itemContainerClass,
    testId,
  } = props;

  const {
    id,
    icon,
    title,
    subtitle,
    isArchived = false,
    titleRightComponent = null,
    disabled = false,
    disabledTooltip = "",
  } = option;

  const onClickItem = itemId => {
    if (disabled) {
      return;
    }
    let selectedItemsLocal = [];
    if (isChecked) {
      selectedItemsLocal = _.filter(selectedItems, ({ id }) => id != itemId);
    } else {
      selectedItemsLocal = [...selectedItems, option];
    }
    setSelectedItems(
      _.map(selectedItemsLocal, item => _.omit(item, FILTER_ITEMS))
    );
  };

  const containerClass = classNames({
    [classes.container]: true,
    [classes.disabledContainer]: disabled,
    [itemContainerClass]: !_.isNil(itemContainerClass),
  });

  const haveSubtitle = !_.isNil(subtitle);

  const titleContainerClass = classNames({
    [classes.titleContainer]: true,
    [classes.titleContainerWithSubtitle]: haveSubtitle,
  });

  return (
    <div
      data-test-id={`${testId}-item-${id}-container`}
      className={containerClass}
      onClick={() => onClickItem(id)}
    >
      <div className={classes.innerContainer}>
        <div className={classes.optionContainer} style={optionContainerStyle}>
          <div className={classes.leftContainer} style={leftContainerStyle}>
            {icon && <div className={classes.iconContainer}>{icon}</div>}
            <ConditionalWrapper
              condition={_.size(title) > 40}
              wrapper={<Tooltip tooltip={title} placement="bottom" />}
              type="wrapperAsElement"
            >
              <div className={classes.descriptionContainer}>
                <div className={classes.alignItemsCenter}>
                  {title ? (
                    <div className={titleContainerClass}>{title}</div>
                  ) : null}

                  {isArchived ? (
                    <div className={classes.archivedText}>
                      {` (${t("common:archived")})`}
                    </div>
                  ) : null}
                </div>
                {haveSubtitle && (
                  <div
                    className={classNames(
                      "text-body-s",
                      classes.subtitleContainer
                    )}
                  >
                    {subtitle}
                  </div>
                )}
              </div>
            </ConditionalWrapper>
            {titleRightComponent}
          </div>
          <div className={classes.rightContainer}>
            <Tooltip
              showArrow={true}
              tooltip={disabledTooltip}
              trigger={disabled ? ["hover"] : [null]}
              placement="left"
              overlayInnerStyle={styles.tooltipOverlayInnerStyle}
            >
              <Checkbox
                testId={`${testId}-item-${id}`}
                isChecked={isChecked}
                disabled={disabled}
              />
            </Tooltip>
          </div>
        </div>
      </div>
    </div>
  );
});

GroupedListItem.displayName = "GroupedListItem";

export default GroupedListItem;
